import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
export function OptionSelector({ label, options, selected, onChange, disabled }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const current = options.find((option) => option.value === selected) ?? options[0];
    useEffect(() => {
        if (!open)
            return;
        function handleClick(event) {
            if (ref.current && !ref.current.contains(event.target))
                setOpen(false);
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [open]);
    return (_jsxs("div", { className: "option-selector", ref: ref, children: [_jsx("label", { children: label }), _jsxs("button", { className: "option-selector-trigger", type: "button", onClick: () => !disabled && setOpen((value) => !value), disabled: disabled, "aria-expanded": open, children: [_jsx("span", { children: current?.label ?? "Select" }), _jsx("span", { className: "option-selector-chevron", children: open ? "▲" : "▼" })] }), open && (_jsx("div", { className: "option-selector-dropdown", children: options.map((option) => (_jsxs("button", { type: "button", className: `option-selector-option${option.value === selected ? " option-selector-option--active" : ""}`, onClick: () => {
                        onChange(option.value);
                        setOpen(false);
                    }, children: [_jsx("span", { className: "option-selector-option-name", children: option.label }), option.description && (_jsx("span", { className: "option-selector-option-description", children: option.description }))] }, option.value))) }))] }));
}
//# sourceMappingURL=OptionSelector.js.map